
export const cmsEntryPoint = "google.analytics";
//export const cmsEntryPoint = "orders.orders";
export const cmsName = "BAROK 032";